import { Button } from "@/components/ui/button";
import { MoonIcon, SunIcon } from "lucide-react";
import { useTheme, ThemeType } from "@/lib/theme-context";

type ThemeToggleProps = {
  variant?: "outline" | "default" | "destructive" | "secondary" | "ghost" | "link";
  size?: "icon" | "default" | "sm" | "lg";
};

export default function ThemeToggle({ 
  variant = "outline", 
  size = "icon" 
}: ThemeToggleProps) {
  const { theme, setTheme } = useTheme();
  const isDarkMode = theme === 'dark';

  const toggleDarkMode = () => {
    setTheme(isDarkMode ? 'standard' as ThemeType : 'dark' as ThemeType);
  };

  return (
    <Button
      variant={variant}
      size={size}
      onClick={toggleDarkMode}
      aria-label={isDarkMode ? "Switch to light mode" : "Switch to dark mode"}
    >
      {isDarkMode ? (
        <SunIcon className="h-[1.2rem] w-[1.2rem]" />
      ) : (
        <MoonIcon className="h-[1.2rem] w-[1.2rem]" />
      )}
    </Button>
  );
}
